let contactId = 0,
	contactRegionList = '',
	contactGroupList = [],
	contactCustomFieldList = '',
	contactCompanyCustomFieldList = '',
	gridContactGroups,
	gridContactRegions,
	cgrouptree,
	lastSaveContext = '',
	preReloadGridScrollPosition = 0,
	lastIsAddToProject = false;

function myInfoSave(saveContext, isAddToProject, isForceSave) {

	lastIsAddToProject = isAddToProject;

	var errElem = null;
	lastSaveContext = saveContext;

	var emailAddress = jQuery('#myEmail').val().trim();
	ClearValidationError('#myEmail');
	if (emailAddress.length > 0 && !PJQ.helpers.validators.validateEmail(emailAddress,!settings.IsForceEmailSingle).success) {
		SetValidationError('#myEmail', 'Email address is invalid.');
		errElem = jQuery('#myEmail');
	}
	else if (emailAddress.length > 0 && settings.IsForceEmailSingle && (emailAddress.indexOf(',') != -1 || emailAddress.indexOf(';') != -1)) {
		SetValidationError('#myEmail', 'Please enter only one Email address.');
		errElem = jQuery('#myEmail');
	}
	else if (emailAddress.length == 0 && jQuery('#myEmail').hasClass('required')) {
		SetValidationError('#myEmail', 'Email address is required.');
		errElem = jQuery('#myEmail');
	}

	if (jQuery('#myFax').hasClass('required') && !validator.element('#myFax'))
		errElem = jQuery('#myFax');

	if (!validator.element('#myPhone'))
		errElem = jQuery('#myPhone');

	if (jQuery('#myCountry').hasClass('selectREQ')) {
		if (!validator.element('#myCountry'))
			errElem = jQuery('#myCountry');
	}

	if (!validator.element('#myZip'))
		errElem = jQuery('#myZip');

	if (jQuery('#myCountry').val() == 'US') {
		if (jQuery('#myStateUS').hasClass('selectREQ')) {
			if (!validator.element('#myStateUS'))
				errElem = jQuery('#myStateUS');
		}
	}
	else {
		if (jQuery('#myStateCA').hasClass('selectREQ')) {
			if (!validator.element('#myStateCA'))
				errElem = jQuery('#myStateCA');
		}
	}

	if (jQuery('#myCity').hasClass('required')) {
		if (!validator.element('#myCity'))
			errElem = jQuery('#myCity');
	}

	if (jQuery('#myAddress1').hasClass('required')) {
		if (!validator.element('#myAddress1'))
			errElem = jQuery('#myAddress1');
	}


	if (!validator.element('#myContactName'))
		errElem = jQuery('#myContactName');

	if (!validator.element('#myCompanyName'))
		errElem = jQuery('#myCompanyName');

	ClearValidationError('#myPrevailingWage');
	if (editContact.IsABRequiredFields && editContact.IsUnionStatusRequired) {

		if ((jQuery('#myUnion:checked').length == 0) &&
			(jQuery('#myNonUnion:checked').length == 0) &&
			(jQuery('#myPrevailingWage:checked').length == 0)) {
			SetValidationError('#myPrevailingWage', 'Labor status is required.');
			errElem = jQuery("#myPrevailingWage");
		}
	}

	if (settings.GroupCount > 0) {
		if (settings.ShouldUseOldGroupSelector) {
			if (settings.GroupLevel <= 1 && (!editContact.IsDirectoryContact || (editContact.IsDirectoryContact && settings.HasGroupsLinked))) {
				if (gridContactGroups.getRowsNum() == 0)
					contactGroupList = null;
				else {
					for (let i = 0; i < gridContactGroups.getRowsNum(); i++) {
						let rId = gridContactGroups.getRowId(i);
						if (gridContactGroups.cells(rId, 0).getValue() == '1' && !isNaN(rId)) {
							contactGroupList.push(parseInt(rId));
						}
					}
				}
			}
			else {
				if (cgrouptree.getSubItems(0).length == 0)
					contactGroupList = null;
				else {
					contactGroupList = _.map(cgrouptree.getAllChecked().split(','), function (idStr) {
						return parseInt(idStr);
					});
				}
			}
		}
		else {
			contactGroupList = _.map(contactGroupSelector.getGroupsData().selected, function (group) {
				return group.id;
			});
		}

		let groupCount = _.size(contactGroupList);
		if (groupCount === 0 && jQuery('#myTrades').hasClass('pjq-required') && editContact.IsABRequiredFields) {
			var tabIndex = 0;
			if (jQuery('#myAdditionalInfoCompany tbody tr td').length > 0)
				tabIndex++;
			if (jQuery("#myinfo-additional").accordion("option", "active") != tabIndex && null == errElem)
				jQuery("#myinfo-additional").accordion("option", "active", tabIndex);

			if (jQuery('label.pjq-errortext', jQuery('#myTrades').parent()).length != 0)
				jQuery('label.pjq-errortext', jQuery('#myTrades').parent()).remove();
			jQuery('#myTrades').parent().append("<label for='myTrades' class='pjq-errortext'><br />Please check at least one selection.</label>");

			jQuery('#myTrades').addClass('pjq-errortext');
			if (null == errElem)
				errElem = jQuery('#myTrades');
		}
		else if (groupCount > 1 && jQuery('#myTrades').hasClass('pjq-single-group-choice') && editContact.IsABRequiredFields) {
			var tabIndex = 0;
			if (jQuery('#myAdditionalInfoCompany tbody tr td').length > 0)
				tabIndex++;
			if (jQuery("#myinfo-additional").accordion("option", "active") != tabIndex && null == errElem)
				jQuery("#myinfo-additional").accordion("option", "active", tabIndex);

			if (jQuery('label.pjq-errortext', jQuery('#myTrades').parent()).length != 0)
				jQuery('label.pjq-errortext', jQuery('#myTrades').parent()).remove();
			jQuery('#myTrades').parent().append("<label for='myTrades' class='pjq-errortext'><br />Please check only one selection.</label>");

			jQuery('#myTrades').addClass('pjq-errortext');
			if (null == errElem)
				errElem = jQuery('#myTrades');
		}
		else if (groupCount > settings.SubGroupsRestrictChoiceCount && jQuery('#myTrades').hasClass('pjq-restrict-group-choice') && editContact.IsABRequiredFields) {
			var tabIndex = 0;
			if (jQuery('#myAdditionalInfoCompany tbody tr td').length > 0)
				tabIndex++;
			if (jQuery("#myinfo-additional").accordion("option", "active") != tabIndex && null == errElem)
				jQuery("#myinfo-additional").accordion("option", "active", tabIndex);

			if (jQuery('label.pjq-errortext', jQuery('#myTrades').parent()).length != 0)
				jQuery('label.pjq-errortext', jQuery('#myTrades').parent()).remove();
			jQuery('#myTrades').parent().append("<label for='myTrades' class='pjq-errortext'><br />Please check up to " + settings.SubGroupsRestrictChoiceCount.toString() + " selections.</label>");

			jQuery('#myTrades').addClass('pjq-errortext');
			if (null == errElem)
				errElem = jQuery('#myTrades');
		}
		else {
			jQuery('#myTrades').removeClass('pjq-errortext');
			jQuery('label.pjq-errortext', jQuery('#myTrades').parent()).remove();
		}
	}

	if (settings.RegionCount > 0 && gridContactRegions != null) {
		contactRegionList = '';
		for (var i = 0; i < gridContactRegions.getRowsNum(); i++) {

			var rId = gridContactRegions.getRowId(i);
			if (gridContactRegions.cells(rId, 0).getValue() == '1')
				contactRegionList += rId + ',';
		}
		if (contactRegionList.length > 0)
			contactRegionList = contactRegionList.substring(0, contactRegionList.length - 1);

	}

	jQuery('#myAdditionalInfoCompany tbody tr td input.required,#myAdditionalInfoCompany tbody tr td input.date, #myAdditionalInfoCompany tbody tr td span input.required, #myAdditionalInfoCompany tbody tr td select.selectREQ, #myAdditionalInfoCompany tbody tr td div.pjq-required').each(function () {
		var hasError = false;
		if (jQuery(this).prop("tagName") == 'DIV' && jQuery(this).hasClass('pjq-required')) {
			if (jQuery("input[type='checkbox']:checked", this).length == 0) {
				hasError = true;
				jQuery(this).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please check at least one selection.</label>");
				jQuery(this).addClass('pjq-errortext');
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		else if (!validator.element(this)) {
			hasError = true;
		}

		if (hasError) {
			if (null == errElem) {
				var addAccIndex = 1;
				addAccIndex = addAccIndex - 1;
				if (jQuery("#company-info-additional").accordion("option", "active") != addAccIndex)
					jQuery("#company-info-additional").accordion("option", "active", addAccIndex);
			}
			errElem = jQuery(this);
		}
	});


	jQuery('#myAdditionalInfo tbody tr td input.required,#myAdditionalInfo tbody tr td input.date, #myAdditionalInfo tbody tr td span input.required, #myAdditionalInfo tbody tr td select.selectREQ, #myAdditionalInfo tbody tr td div.pjq-required,#myAdditionalInfoCompany tbody tr td input.required,#myAdditionalInfoCompany tbody tr td input.date, #myAdditionalInfoCompany tbody tr td span input.required, #myAdditionalInfoCompany tbody tr td select.selectREQ, #myAdditionalInfoCompany tbody tr td div.pjq-required').each(function () {
		var hasError = false;
		if (jQuery(this).prop("tagName") == 'DIV' && jQuery(this).hasClass('pjq-required')) {
			if (jQuery("input[type='checkbox']:checked", this).length == 0) {
				hasError = true;
				jQuery(this).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please check at least one selection.</label>");
				jQuery(this).addClass('pjq-errortext');
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		else if (!validator.element(this)) {
			hasError = true;
		}

		if (hasError) {
			if (null == errElem) {
				var addAccIndex = 2;
				if (jQuery('#myTrades').length == 0 || settings.GroupCount == 0)
					addAccIndex = addAccIndex - 1;
				if (jQuery('#myRegions').length == 0 || settings.RegionCount == 0)
					addAccIndex = addAccIndex - 1;
				if (jQuery("#myinfo-additional").accordion("option", "active") != addAccIndex)
					jQuery("#myinfo-additional").accordion("option", "active", addAccIndex);
			}
			errElem = jQuery(this);
		}
	});


	if (null != errElem) {
		errElem.focus();
		return;
	}

	contactCustomFieldList = '';
	jQuery("#myAdditionalInfo tbody tr td input[type='text'],#myAdditionalInfo tbody tr td input.date, #myAdditionalInfo tbody tr td span input, #myAdditionalInfo tbody tr td select, #myAdditionalInfo tbody tr td div").each(function () {
		var fieldId = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('_') + 1);
		if (jQuery(this).prop('tagName') == 'SELECT') {
			contactCustomFieldList = contactCustomFieldList + fieldId + '{|}';
			jQuery('option:selected', jQuery(this)).each(function () {
				contactCustomFieldList = contactCustomFieldList + jQuery(this).val() + ',';
			});
			if (contactCustomFieldList.substring(contactCustomFieldList.length - 1) == ',')
				contactCustomFieldList = contactCustomFieldList.substring(0, contactCustomFieldList.length - 1);
			contactCustomFieldList = contactCustomFieldList + '||||';
		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			contactCustomFieldList = contactCustomFieldList + fieldId + '{|}';
			jQuery("input[type='checkbox']:checked", this).each(function () {
				contactCustomFieldList = contactCustomFieldList + jQuery(this).val() + ',';
			});
			if (contactCustomFieldList.substring(contactCustomFieldList.length - 1) == ',')
				contactCustomFieldList = contactCustomFieldList.substring(0, contactCustomFieldList.length - 1);

			contactCustomFieldList = contactCustomFieldList + '||||';
		}
		else {
			contactCustomFieldList = contactCustomFieldList + fieldId + '{|}' + jQuery(this).val().replace(/\|/g, '') + '||||';
		}
	});
	if (contactCustomFieldList.length > 0)
		contactCustomFieldList = contactCustomFieldList.substring(0, contactCustomFieldList.length - 4);

	contactCompanyCustomFieldList = '';
	jQuery("#myAdditionalInfoCompany tbody tr td input[type='text'],#myAdditionalInfoCompany tbody tr td input.date, #myAdditionalInfoCompany tbody tr td span input, #myAdditionalInfoCompany tbody tr td select, #myAdditionalInfoCompany tbody tr td div").each(function () {
		var fieldId = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('_') + 1);
		if (jQuery(this).prop('tagName') == 'SELECT') {
			contactCompanyCustomFieldList = contactCompanyCustomFieldList + fieldId + '{|}';
			jQuery('option:selected', jQuery(this)).each(function () {
				contactCompanyCustomFieldList = contactCompanyCustomFieldList + jQuery(this).val() + ',';
			});
			if (contactCompanyCustomFieldList.substring(contactCompanyCustomFieldList.length - 1) == ',')
				contactCompanyCustomFieldList = contactCompanyCustomFieldList.substring(0, contactCompanyCustomFieldList.length - 1);
			contactCompanyCustomFieldList = contactCompanyCustomFieldList + '||||';
		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			contactCompanyCustomFieldList = contactCompanyCustomFieldList + fieldId + '{|}';
			jQuery("input[type='checkbox']:checked", this).each(function () {
				contactCompanyCustomFieldList = contactCompanyCustomFieldList + jQuery(this).val() + ',';
			});
			if (contactCompanyCustomFieldList.substring(contactCompanyCustomFieldList.length - 1) == ',')
				contactCompanyCustomFieldList = contactCompanyCustomFieldList.substring(0, contactCompanyCustomFieldList.length - 1);

			contactCompanyCustomFieldList = contactCompanyCustomFieldList + '||||';
		}
		else {
			contactCompanyCustomFieldList = contactCompanyCustomFieldList + fieldId + '{|}' + jQuery(this).val().replace(/\|/g, '') + '||||';
		}
	});
	if (contactCompanyCustomFieldList.length > 0)
		contactCompanyCustomFieldList = contactCompanyCustomFieldList.substring(0, contactCompanyCustomFieldList.length - 4);

	var myState = '';
	if (jQuery('#myCountry').val() == 'CA')
		myState = jQuery('#myStateCA').val();
	else
		myState = jQuery('#myStateUS').val();

	PanteraScript.PanteraScriptService.UpdateContactInfoAdmin(pjqSessionId, contactId, jQuery('#myCompanyName').val(), jQuery('#myContactTitle').val(),
		jQuery('#myContactName').val(), jQuery('#myAddress1').val(), jQuery('#myAddress2').val(), jQuery('#myCity').val(),
		myState, jQuery('#myZip').val(), jQuery('#myCountry').val(), jQuery('#myPhone').val(),
		jQuery('#myPhoneExt').val(), jQuery('#myFax').val(), jQuery('#myCell').val(), jQuery('#myEmail').val(), (jQuery('#myUnion:checked').length > 0), (jQuery('#myNonUnion:checked').length > 0), (jQuery('#myPrevailingWage:checked').length > 0), (jQuery('#myPublicSector:checked').length > 0), (jQuery('#myPrivateSector:checked').length > 0), (jQuery('#myDBE:checked').length > 0), (jQuery('#myDVBE:checked').length > 0), (jQuery('#myMBE:checked').length > 0), (jQuery('#mySBE:checked').length > 0), (jQuery('#mySDVBE:checked').length > 0), (jQuery('#myWBE:checked').length > 0),
		contactGroupList.join(','), contactRegionList, contactCustomFieldList, contactCompanyCustomFieldList, jQuery('#myContactNotes').val(), isAddToProject ? true : false, jQuery('#myContactStatus').val() == 'true', (isForceSave === true), myInfoSaveC, onScriptError);

	if (window.editContactRegionsMap) {
		window.editContactRegionsMap.save();
	}
}

function cgrouptreeclick(id) {
	if (parseInt(id) <= 0) {
		if (cgrouptree.hasChildren(id)) {
			if (cgrouptree.getOpenState(id) == 1)
				cgrouptree.closeItem(id);
			else
				cgrouptree.openItem(id);
		}
		return;
	}
	if (cgrouptree.isItemChecked(id))
		cgrouptree.setCheck(id, 0);
	else
		cgrouptree.setCheck(id, 1);
}

function cgrouptreeAfterLoad() {
	if (editContact.IsDirectoryContact && !settings.IsDocumentClerk && !settings.IsAllowDirectoryEdit) {
		var items = cgrouptree.getAllSubItems(0).split(",");
		for (var i = 0; i < items.length; i++) {
			var subItems = cgrouptree.getAllSubItems(items[i]).split(",");
			for (var j = 0; j < subItems.length; j++) {
				cgrouptree.disableCheckbox(subItems[j], 1);
			}
		}
	}
	jQuery('button', 'div.ui-dialog-buttonset').button('enable');
}

window.contactGroupSelector = null;
window.editContact = null;
function PJQProjectWallAdminEditContactInitialize(contact) {
	editContact = contact;
	contactId = contact.ContactId;
	if (jQuery('#myTrades').length > 0 && settings.GroupCount > 0) {
		if (settings.ShouldUseOldGroupSelector) {
			if (settings.GroupLevel <= 1 && (!editContact.IsDirectoryContact || (editContact.IsDirectoryContact && settings.HasGroupsLinked))) {
				gridContactGroups = new dhtmlXGridObject('myTrades');
				gridContactGroups.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
				gridContactGroups.setHeader(contact.GroupLabel + ",&nbsp;");
				gridContactGroups.setNoHeader(true);
				gridContactGroups.setInitWidthsP("6,90");
				gridContactGroups.setColAlign("center,left");
				gridContactGroups.setColTypes("ch,ro");
				gridContactGroups.setColSorting("na,na");
				gridContactGroups.enableTooltips("false,true");
				gridContactGroups.setSkin(pjqGridTheme);
				gridContactGroups.init();
				gridContactGroups.load('/DesktopModules/PJQProjectWallAdmin/GetGroupListContact.aspx?sessionid=' + pjqSessionId + '&c=' + contact.ContactId.toString(), function () {
					jQuery('button', 'div.ui-dialog-buttonset').button('enable');
				});
			}
			else {
				var directoryFilter = '';
				if (contact.IsDirectoryContact)
					directoryFilter = 1;
				jQuery('#myTrades').addClass('pjq-groups-multi-level');
				cgrouptree = new dhtmlXTreeObject("myTrades", "100%", "100%", 0);
				cgrouptree.setImagePath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxTree/imgs/");
				cgrouptree.enableCheckBoxes(1);
				cgrouptree.enableMultiLineItems("300px");
				cgrouptree.enableTreeLines(false);
				cgrouptree.enableTreeImages(false);
				cgrouptree.setOnClickHandler(cgrouptreeclick);
				cgrouptree.setDataMode('json');
				cgrouptree.loadJSON('/DesktopModules/PJQProjectWallAdmin/GetGroupTreeContact.aspx?sessionid=' + PJQ.app.session.id + '&c=' + contact.ContactId.toString() + '&dir=' + directoryFilter, cgrouptreeAfterLoad);
			}
		}
		else {
			let canEdit = false;
			if (!editContact.IsDirectoryContact || settings.IsDocumentClerk || (editContact.IsDirectoryContact && settings.IsAllowDirectoryEdit)) {
				canEdit = true;
			}
			contactGroupSelector = new PJQ.views.groups.GroupSelector({
				el: $('#myTrades'),
				selectedGroups: new PJQ.collections.groups.Groups(PJQ.helpers.objectHelpers.convertObjectCamelcase(contact.Groups)),
				contactId: editContact.ContactId,
				isAdmin: !settings.IsDocumentClerk,
				canEdit: canEdit
			});
		}
	}
	else {
		jQuery('#edit-contact-groups-header').addClass('pjq-hidden');
	}

	if (settings.IsRegionsMapEnabled && !contact.IsDirectoryContact) {
		let canEdit = false;
		if (!editContact.IsDirectoryContact || settings.IsDocumentClerk || (editContact.IsDirectoryContact && settings.IsAllowDirectoryEdit)) {
			canEdit = true;
		}
		window.editContactRegionsMap = new PJQ.views.workAreas.WorkAreaMap({
			el: $('#regionsOuterContainer'),
			contactId: contact.ContactId,
			isInline: false,
			isEdit: canEdit,
			isSync: false
		});

		jQuery('#myRegions').hide();
	}
	else if (jQuery('#myRegions').length > 0 && settings.RegionCount > 0) {
		gridContactRegions = new dhtmlXGridObject('myRegions');
		gridContactRegions.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
		gridContactRegions.setHeader(contact.RegionLabel + ",&nbsp;");
		gridContactRegions.setNoHeader(true);
		gridContactRegions.setInitWidthsP("6,90");
		gridContactRegions.setColAlign("center,left");
		gridContactRegions.setColTypes("ch,ro");
		gridContactRegions.setColSorting("na,na");
		gridContactRegions.enableTooltips("false,true");
		gridContactRegions.setSkin(pjqGridTheme);
		gridContactRegions.init();
		gridContactRegions.load('/DesktopModules/PJQProjectWallAdmin/GetRegionListContact.aspx?sessionid=' + pjqSessionId + '&c=' + contact.ContactId.toString());
	}
	else {
		jQuery('#edit-contact-regions-header').addClass('pjq-hidden');
	}

	jQuery("#myPhone").mask('(999) 999-9999', {
		placeholder: " "
	});
	jQuery("#myFax").mask('(999) 999-9999', {
		placeholder: " "
	});
	jQuery("#myCell").mask('(999) 999-9999', {
		placeholder: " "
	});
	if (contact.Country == 'CA') {
		jQuery("#myPostalCode").mask('a9a 9a9', {
			placeholder: " "
		});
		jQuery('#myStateUS').addClass('pjq-hidden');
		jQuery('#myStateCA').removeClass('pjq-hidden');
		jQuery('#myZip').removeClass('zipcodeUS');
		jQuery('#myZip').addClass('zipcodeCA');
	}
	else {
		jQuery("#myPostalCode").mask('99999', {
			placeholder: " "
		});
		jQuery('#myStateUS').removeClass('pjq-hidden');
		jQuery('#myStateCA').addClass('pjq-hidden');
		jQuery('#myZip').addClass('zipcodeUS');
		jQuery('#myZip').removeClass('zipcodeCA');
	}

	jQuery('#myPrevailingWageLabel').text(settings.PrevailingWageLabel);

	jQuery("#myAdditionalInfo tbody tr td input.pjq-date-field-width,#myAdditionalInfoCompany tbody tr td input.pjq-date-field-width").mask('99/99/9999', {
		placeholder: " "
	});
	jQuery("#myAdditionalInfo tbody tr td input.pjq-numeric-field-width,#myAdditionalInfoCompany tbody tr td input.pjq-numeric-field-width").each(function () {
		var minVal = 0;
		if (jQuery(this).attr('min') != '')
			minVal = parseInt(jQuery(this).attr('min'));
		var maxVal = 2147483647;
		if (jQuery(this).attr('max') != '')
			maxVal = parseInt(jQuery(this).attr('max'));
		jQuery(this).spinner({
			min: minVal,
			max: maxVal
		});
	});
	jQuery('#myAdditionalInfo tbody tr td input.pjq-date-field-width,#myAdditionalInfoCompany tbody tr td input.pjq-date-field-width').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: function (name, sender) {
			validator.element('#' + jQuery(sender).attr('id'));
		}
	});
	jQuery("select.pjq-choice-field-width").each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("option[value='" + x[i] + "']").attr('selected', 'selected');
		}
	});
	jQuery("div.pjq-multiple-choice-list").each(function () {
		var x = jQuery(this).attr('data-choice-list').split(',');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			jQuery(this).find("input[value='" + x[i] + "']").prop('checked', true);
		}
	});

	if (contact.SubGroupsRestrictChoiceCount == 1) {
		jQuery('#myTrades').addClass('pjq-single-group-choice');
	}
	else if (contact.SubGroupsRestrictChoiceCount > 1) {
		jQuery('#myTrades').addClass('pjq-restrict-group-choice');
	}

	jQuery("#myinfo-additional").accordion({
		heightStyle: "content",
		active: false,
		collapsible: true
	});

	jQuery("#myinfo-additional").on('accordionactivate', function (event, ui) {
		let accordIndex = $("#myinfo-additional").accordion("option", "active"),
			accordId = $($("#myinfo-additional").children('div')[accordIndex]).attr('id');
		if (accordId === 'myRegions-container' && window.editContactRegionsMap) {
			window.editContactRegionsMap.refresh();
		}
	});

	if (contact.IsDirectoryContact) {
		if (!settings.IsDocumentClerk && !settings.IsAllowDirectoryEdit) {
			jQuery('#dialog-edit-contact').find('input, select, textarea').attr('disabled', true);
		}

		// 2018-02-01 : We want to show this now.
		jQuery('#myUnion').closest('tr').show();

		jQuery('#myPrivateSector').closest('tr').hide();
		jQuery('#myDBE').closest('tr').hide();
		jQuery('#myContactNotes').closest('tr').hide();
		jQuery('#myRegions').add(jQuery('#myRegions-container').prev('h3')).hide();
		//Directory/Network Icons
		if (contact.IsDirectoryContact == true && contact.IsNetworkContact == false) {
			var dnIcon = jQuery('<span class="editDirectoryContactStatus"><span class="directoryContactIcon"></span><a style="text-decoration:none;">Directory Contact</a></span>');
		}
		else if (contact.IsDirectoryContact == true && contact.IsNetworkContact == true && contact.NetworkVerificationLevel == 1) {
			var dnIcon = jQuery('<span class="editQualifiedNetworkContactStatus"><span class="networkContactPendingVerifiedIcon"></span><a style="text-decoration:none;">Qualified Network Contact</a></span>');
		}
		else if (contact.IsDirectoryContact == true && contact.IsNetworkContact == true && contact.NetworkVerificationLevel == 2) {
			var dnIcon = '<span class="editVerifiedNetworkContactStatus"><span class="networkContactVerifiedIcon"></span><a style="text-decoration:none;">Verified Network Contact</a></span>';

		}
		jQuery('#directoryNetworkIcons').append(dnIcon);

	}
	else {
		jQuery('#dialog-edit-contact').find('input:not(.group-select), select, textarea').attr('disabled', false);
	}

	if (contact.IsPublicContact) {
		$('#dialog-edit-contact').find('.pjq-field-value').find('input,select,textarea').prop('disabled', true);
		$('#dialog-edit-contact').find("#myAdditionalInfoCompany,#myAdditionalInfo").find('input,select,textarea').prop('disabled', false);
	}

	PJQProjectWallAdminEditContactOverride();
}

function PJQProjectWallAdminEditContactOverride() {
};

function myInfoSaveC(response) {
	if (response === 'DUPLICATE_EMAIL') {
		showInfoDialogPWall('Duplicate Email Detected', 'Another contact in your Address Book has this email address already.  Do you still want to save this record?', 'ui-icon-alert', 'duplicate-email');
		return;
	}

	jQuery("#dialog-edit-contact").dialog('close');

	if (lastSaveContext == 'itb' || lastSaveContext == 'itbadd')
		EditContactCC();
	else if (lastSaveContext == 'itbnew')
		EditContact(parseInt(subgridCheckedRows) * -1, EditContactCNew);
	else
		EditContactPCCFCC();
	editContact = null;
	//fix for firefox scroll bug
	//global var since we are going to use this from another templates script
	let $newModule = $('.nav-content');
	if($newModule){
		preReloadGridScrollPosition = $newModule[0].scrollTop;
	}
	else {
		preReloadGridScrollPosition = window.scrollY;
	}

	if (lastSaveContext != 'itbnew')
		showInfoDialogPWall('Contact Info Saved', response);
}

function myCountryChangedPW() {
	if (jQuery('#myCountry').val() == 'CA') {
		jQuery('#myStateUS').addClass('pjq-hidden');
		jQuery('#myStateCA').removeClass('pjq-hidden');
		jQuery('#myStateCA').val('');
		jQuery('#myZip').val('');
		jQuery('#myZip').mask("a9a-9a9");
		jQuery('#myZip').removeClass('zipcodeUS');
		jQuery('#myZip').addClass('zipcodeCA');
		jQuery('#myStateCA').focus();
	}
	else {
		jQuery('#myStateCA').addClass('pjq-hidden');
		jQuery('#myStateUS').removeClass('pjq-hidden');
		jQuery('#myStateUS').val('');
		jQuery('#myStateUS').focus();
		jQuery('#myZip').val('');
		jQuery('#myZip').mask("99999");
		jQuery('#myZip').addClass('zipcodeUS');
		jQuery('#myZip').removeClass('zipcodeCA');
	}
}

function GetVCard(id) {
	PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'contacts',
			value: id
		},
		{
			endpoint: 'vcard'
		}
	]));
}
